import { BreadcrumbContext } from '@Components/UI/Layout/Layout';
import { useTypedSelector } from '@Features/store';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import React, { useContext, useEffect } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ClassRoomsTable from './ClassRoomsTable';

const ClassRooms: React.FC = () => {
	const routeGroup = useRouteGroup('classrooms');
	const { classrooms_enabled, standalone_courses_enabled, bundles_enabled } = useTypedSelector(
		(state) => state.settings
	);

	const { path, url } = useRouteMatch();
	const { isCurrent } = useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/classrooms',
		routeGroup: routeGroup,
		routePlacement: 2,
	});
	const { removeLink } = useContext(BreadcrumbContext);
	useEffect(() => {
		if (isCurrent) {
			removeLink && removeLink('classroom');
		}
	}, [isCurrent]);

	return (
		<Switch>
			{routeGroup && !Array.isArray(routeGroup) && (
				<>
					{/* Redirect's from/exact props only work as a DIRECT child of
					    Switch; inside this fragment they are ignored and the
					    Redirect fires unconditionally on mount — which rewrote
					    every deep URL (lecture/test refresh) to the overview
					    once settings arrived. Guard it with a Route instead. */}
					{!classrooms_enabled && standalone_courses_enabled && (
						<Route exact path={url}>
							<Redirect to={`${url}/standalone-courses`} />
						</Route>
					)}
					<Route exact path={url}>
						<ClassRoomsTable />
					</Route>

					{routeGroup.routes.map((_) => {
						if (_.route === 'standalone-courses' && !standalone_courses_enabled)
							return null;
						if (_.route === 'bundles' && !(standalone_courses_enabled && bundles_enabled))
							return null;
						// Drop the <Route> too, not just the nav button, so a direct
						// URL cannot reach a page the platform mode has turned off.
						if (_.requiresClassrooms && !classrooms_enabled) return null;
						return (
							<Route key={_.route} strict path={`${path}/${_.route}`}>
								{_.component}
							</Route>
						);
					})}
				</>
			)}
		</Switch>
	);
};

export default ClassRooms;
